import React from "react";

const typeViewData = [
    { id: 'SMALL', code : 'SMALL'}
    , { id: 'MEDIUM', code : 'MEDIUM'}
    , { id: 'LARGE', code : 'LARGE'}
];

export const typeViewProvider = {
    getOptions ,
    getItem
};

async function getOptions() {
    try {
        return typeViewData.map((item) => {
            return (
                {
                    id: item.id,
                    value: item.code,
                    label: <div><label>{item.code}</label></div>
                }
            )
        });
    } catch (error) {
        console.log(error.message)
    }
}

function getItem(id) {
    if (!id)
        return null;

    const item = typeViewData.find(tvd => tvd.id === id)
    try {
        return (
            {
                id: item.id,
                value: item.code,
                label: <div><label>{item.code}</label></div>,
            }
        );
    } catch (error) {
        console.log(error.message)
    }
}